export type ResponseTransformer = (payload: any) => any

export const createResponseTransformer = <M> (...properties: string[]): ResponseTransformer => (model) => {
  let result = { ...model }
  result = stripData(result)
  result = stripDataFromProperties(result, properties)
  return result as M
}

export const createResponseArrayTransformer = (...properties: string[]): ResponseTransformer  => (payload) => {
  let result = { ...payload }
  result = stripData(result)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return result.map((item: any) => {
    let itemResult = { ...item }

    itemResult = stripDataFromProperties(itemResult, properties)

    return itemResult
  })
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stripData = (payload: any) => !!payload.data ? payload.data : payload
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stripDataFromProperties = (obj: any, properties: string[]): any => {
  const result = { ...obj }

  properties.forEach((propertyLevels) => {
    const propertiesArray = propertyLevels.split('.')
    let propertyData = result

    propertiesArray.forEach((property) => {
      if (propertyData[property]) {
        // Fallback to self, in case `data` property doesn't exist
        propertyData[property] = propertyData[property].data || propertyData[property]

        propertyData = propertyData[property]
      }
      else if (propertyData && Array.isArray(propertyData)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        propertyData = propertyData.reduce((newPropertyData: any, child: any) => {
          if (child[property]) {
            child[property] = child[property].data || child[property]

            newPropertyData.push(child[property])
          }

          return newPropertyData
        }, [])
      }
    })
  })

  return result
}
